import { Button, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { DecisionTree } from "../../types/api/decision-tree";

type TreeSelectProps = {
  decisionTreeList: DecisionTree[];
  onSelectDecisionTree: (tree: DecisionTree) => void;
};

const TreeSelect = ({
  decisionTreeList,
  onSelectDecisionTree,
}: TreeSelectProps) => {
  const [selectedTree, setSelectedTree] = useState<DecisionTree>();

  return (
    <div className="tree-select-container">
      <Select
        displayEmpty
        value={selectedTree}
        renderValue={(value) => {
          if (!value) {
            return (
              <p style={{ color: "var(--Gray-500, #64748B)" }}>
                Sélectionner une infection
              </p>
            );
          }

          return selectedTree?.name;
        }}
        onChange={(value) => {
          setSelectedTree(
            decisionTreeList.find(
              (tree) => tree.id === +(value.target.value ?? 0)
            )
          );
        }}
        className="tree-select"
      >
        {decisionTreeList.map((tree) => (
          <MenuItem key={tree.id} value={tree.id}>
            {tree.name}
          </MenuItem>
        ))}
      </Select>
      <Button
        variant="contained"
        sx={{ padding: "14px 16px", fontSize: "14px", fontWeight: 600 }}
        onClick={() => {
          if (selectedTree) onSelectDecisionTree(selectedTree);
        }}
      >
        Sélectionner
      </Button>
    </div>
  );
};

export default TreeSelect;
